import React from "react";
import { Button, Modal, Divider } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../app/common/modals/modalReducer";
import TotalTimeReport from "../staff/TimeTrackList/TotalTimeReport";

export default function TotalReport(props) {
    const dispatch = useDispatch();

    return (
        <Modal size="fullscreen" open={true} onClose={() => dispatch(closeModal())} style={{ marginLeft: 40 }} closeOnDimmerClick={false} trigger={<Button>Show Modal</Button>} closeIcon>
            <Modal.Header>&nbsp;</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div className="content_top">
                        <img className="img_header" src="/assets/your_documents.png" alt="Your Documents" />

                        <h2 className="ui center aligned header">Total Time Report</h2>
                    </div>

                    <Divider />

                    <TotalTimeReport />
                </Modal.Description>
            </Modal.Content>
        </Modal>
    );
}
